import React from 'react';
import { IconButtonProps } from './types';
import cx from 'classnames';
import styles from './IconButton.module.scss';
import {
    getIconBtnSizeShapeStyle,
    getIconBtnVariantStyle,
    getIconColor,
    getIconSize,
} from './utils';

const FloatingButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
    (
        { size = 'large', shape = 'rounded', variant = 'primary', Icon, className, ...restProps },
        ref,
    ) => {
        const floatingBtnClass = cx(
            styles['icon-btn'],
            getIconBtnSizeShapeStyle(size, shape),
            getIconBtnVariantStyle(variant),
            className,
        );
        return (
            <button ref={ref} className={floatingBtnClass} {...restProps}>
                <Icon color={getIconColor(variant)} size={getIconSize(size)} />
            </button>
        );
    },
);

export default React.memo(FloatingButton);
